import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { HttpClient, HttpClientModule } from "@angular/common/http";
import { FormsModule,ReactiveFormsModule } from '@angular/forms';
import { NgxPaginationModule } from 'ngx-pagination';
import { ToastrModule } from 'ngx-toastr';
import { TranslateLoader, TranslateModule,TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxLoadingModule } from "ngx-loading";
import { CKEditorModule } from 'ng2-ckeditor';
import { TruncatePipe } from "./pipe/truncate.pipe";
import { SafePipe } from "./pipe/safe.pipe";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { DragDropModule } from '@angular/cdk/drag-drop';

// import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
// import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
// import { MatFormFieldModule } from '@angular/material/form-field';
// import { MatInputModule } from '@angular/material/input';
// import { MatIconModule } from '@angular/material/icon';
// import { MatSelectModule } from '@angular/material/select';
// import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './Components/header/header.component';
import { FooterComponent } from './Components/footer/footer.component';
import { SidebarComponent } from './Components/sidebar/sidebar.component';
import { ConfirmBoxComponent } from './Components/confirm-box/confirm-box.component';
import { SigninComponent } from './Auth/signin/signin.component';
import { ChangepasswordComponent } from './Auth/changepassword/changepassword.component';
import { DashboardComponent } from './Pages/dashboard/dashboard.component';
import { ProfileComponent } from './Pages/profile/profile.component';
import { UserListComponent } from './Pages/user-list/user-list.component';
import { StaticListComponent } from './Pages/static-list/static-list.component';
import { StaticEditComponent } from './Pages/static-edit/static-edit.component';
import { SinglecontentlistComponent } from './Pages/singlecontentlist/singlecontentlist.component';
import { ProgramlistComponent } from './Pages/programlist/programlist.component';
import { AlbumlistComponent } from './Pages/albumlist/albumlist.component';
import { UserDetailComponent } from './Pages/user-detail/user-detail.component';
import { AlbumProgramDetailComponent } from './Pages/album-program-detail/album-program-detail.component';
import { CommanListComponent } from './Pages/comman-list/comman-list.component';
import { CommanAddEditComponent } from './Pages/comman-add-edit/comman-add-edit.component';
import { FaqlistComponent } from './Pages/faqlist/faqlist.component';
import { FaqAddEditComponent } from './Pages/faq-add-edit/faq-add-edit.component';
import { ContentDetailComponent } from './Pages/content-detail/content-detail.component';
import { ReferalListComponent } from './Pages/referal-list/referal-list.component';
import { ContactListComponent } from './Pages/contact-list/contact-list.component';
import { CustomerDetailComponent } from './Pages/customer-detail/customer-detail.component';
import { MasterListComponent } from './Pages/master-list/master-list.component';
import { DeletedUserComponent } from './Pages/deleted-user/deleted-user.component';
import { CollabratorComponent } from './Pages/collabrator/collabrator.component';
import { ReportsComponent } from './Pages/reports/reports.component';
import { AppVersionComponent } from './Pages/app-version/app-version.component';
import { TransactionComponent } from './Pages/transaction/transaction.component';
import { WebMediaComponent } from './Pages/web-media/web-media.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    FooterComponent,
    SidebarComponent,
    ConfirmBoxComponent,
    SigninComponent,
    ChangepasswordComponent,
    DashboardComponent,
    ProfileComponent,
    UserListComponent,
    StaticListComponent,
    StaticEditComponent,
    SinglecontentlistComponent,
    ProgramlistComponent,
    AlbumlistComponent,
    UserDetailComponent,
    AlbumProgramDetailComponent,
    CommanListComponent,
    CommanAddEditComponent, 
    FaqlistComponent,
    FaqAddEditComponent,
    ContentDetailComponent,
    ReferalListComponent, 
    SafePipe, ContactListComponent, CustomerDetailComponent, MasterListComponent, DeletedUserComponent, CollabratorComponent, ReportsComponent, 
    AppVersionComponent, TransactionComponent, WebMediaComponent,
  ],
  imports: [
    BrowserModule,
    CKEditorModule,
    AppRoutingModule,
    ReactiveFormsModule,
    FormsModule,
    BrowserAnimationsModule,
    NgxPaginationModule,
    ToastrModule.forRoot(),
    NgxLoadingModule.forRoot({}),
    HttpClientModule,  
    NgxSliderModule,  
    DragDropModule,
    // MatFormFieldModule,
    // MatInputModule,
    // MatIconModule,
    // MatSelectModule,
    // NgxMaterialTimepickerModule,
    // NgMultiSelectDropDownModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
          provide: TranslateLoader,
          useFactory: HttpLoaderFactory,
          deps: [HttpClient]
      }
  }),
  TruncatePipe,
  ],
  providers: [],
  bootstrap: [AppComponent],
})

export class AppModule {
  
 }

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http);
}
